import { useEffect, useState } from "react";
import { api, formatDate, LEAD_KINDS, LEAD_STATUS } from "@/lib/api";

const CARDS = [
  { k: "programmes", label: "Programmes" },
  { k: "en_construction", label: "En construction" },
  { k: "leads", label: "Demandes reçues" },
  { k: "leads_nouveau", label: "Demandes à traiter", accent: true },
];

export const AdminOverview = ({ onNavigate }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-overview">
      <h1 className="font-display text-4xl mt-2">Vue d'ensemble</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {CARDS.map((c) => (
          <div key={c.k} className={`p-6 rounded-sm border ${c.accent ? "bg-[#2F2A28] text-white border-[#2F2A28]" : "bg-white border-[#2F2A28]/10"}`} data-testid={`stat-${c.k}`}>
            <p className={`text-xs uppercase tracking-[0.18em] ${c.accent ? "text-[#D4A373]" : "text-[#756D69]"}`}>{c.label}</p>
            <p className="font-display text-5xl mt-3">{s ? s[c.k] : "–"}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 bg-white border border-[#2F2A28]/10 rounded-sm">
        <div className="flex items-center justify-between p-6 border-b border-[#2F2A28]/10">
          <h2 className="font-display text-2xl">Dernières demandes</h2>
          <button onClick={() => onNavigate("leads")} className="text-sm text-[#C88A58] hover:underline" data-testid="overview-see-leads-button">Tout voir</button>
        </div>
        {s?.recent_leads?.length === 0 && <p className="p-6 text-sm text-[#756D69]">Aucune demande pour le moment.</p>}
        <ul>
          {s?.recent_leads?.map((l) => (
            <li key={l.id} className="p-6 border-b last:border-0 border-[#2F2A28]/5 flex flex-wrap items-center justify-between gap-3" data-testid={`recent-lead-${l.id}`}>
              <div>
                <p className="font-medium">{l.name} <span className="text-[#756D69] text-sm font-normal">· {LEAD_KINDS[l.kind]}</span></p>
                <p className="text-xs text-[#756D69] mt-1">{l.programme_name || "Sans programme"} · {formatDate(l.created_at)}</p>
              </div>
              <span className={`text-xs px-3 py-1 rounded-full ${LEAD_STATUS[l.status].cls}`}>{LEAD_STATUS[l.status].label}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
